export default {"src":"/_next/static/media/purple-gradient-bg.e469bbba.svg","height":1317,"width":1920,"blurWidth":0,"blurHeight":0};